import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface CategoryNavProps {
  active?: string;
}

export default function CategoryNav({ active = 'all' }: CategoryNavProps) {
  return (
    <section className="py-8 bg-secondary-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-grid-line text-primary-500 text-lg"></i>
          <h2 className="text-lg font-heading text-foreground-900">漫画分类</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-5 py-2 rounded-full text-sm font-label whitespace-nowrap cursor-pointer transition-all ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 hover:bg-secondary-200 border border-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}